export default "__VITE_ASSET__vfrtA7e$__"